import React from 'react';
import { LabeledFieldStyle, Label, Field } from './styles';

const LabeledField = ({ label, field, masked = false }) => {
  return field ? (
    <LabeledFieldStyle>
      <Label>{`${label}:`}</Label>
      <Field>{masked ? '********' : field}</Field>
    </LabeledFieldStyle>
  ) : null;
};

export default LabeledField;
